export default "__VITE_ASSET__dQ8nv7Ul__"